function Filter(utilsService) {
  return function(message, length) {
    return utilsService.truncateString(message, length);
  };
}

Filter.$inject = [
  'utilsService'
];

export default Filter;



// WEBPACK FOOTER //
// ./src/filters/truncateStringFilter.js